import { showToastMessage, ToastMessage } from 'common/ToastMessage/ShowToastMessage'
import { showToast } from 'common/ToastMessage'
import { responsiveDesignLogic } from 'hooks/useResponsiveDesign'

export const showErrorMessageToast = (messageString: string) => {
  return showToastMessage(messageString, 'error')
}

export const showIntegrationErrorToast = (messageString: string) => {
  const { isMobile } = responsiveDesignLogic()
  const dismiss = showToast(
    <div onClick={() => isMobile && dismiss()}>
      <ToastMessage toastMessage={messageString} variant="error" />
    </div>,
    0,
  )

  setTimeout(() => dismiss(), isMobile ? 3000 : 5000)
  return dismiss
}
